import { AlertTriangle } from 'lucide-react';
import { ReactNode } from 'react';
import styled from 'styled-components';

interface ErrorStateProps {
  title?: string;
  description?: string;
  action?: ReactNode;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  padding: 48px 24px;
`;

const IconSlot = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: ${({ theme }) => theme.radius.pill};
  background: ${({ theme }) => theme.colors.dangerBg};
  color: ${({ theme }) => theme.colors.danger};
`;

const Title = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: 15px;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const Description = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.font.secondary};
  font-size: 13.5px;
  max-width: 360px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const Action = styled.div`
  margin-top: 8px;
`;

export const ErrorState = ({
  title = 'Algo deu errado',
  description = 'Tente novamente em alguns instantes.',
  action,
}: ErrorStateProps) => (
  <Wrapper role="alert">
    <IconSlot aria-hidden="true">
      <AlertTriangle size={26} />
    </IconSlot>
    <Title>{title}</Title>
    {description && <Description>{description}</Description>}
    {action && <Action>{action}</Action>}
  </Wrapper>
);
